import { Col } from 'antd';
import { Row } from 'antd';
import { useState } from 'react';
import CustomButton from '../../../../../v2-components/Antd/Button';
import CustomDivider from '../../../../../v2-components/Antd/Divider';
import CustomInputNumber from '../../../../../v2-components/Antd/InputNumber';
import CustomModal from '../../../../../v2-components/Antd/Modal';
import { dataAdapter } from './handle/data-adapter.handle';

export default function EditPriceModal(props) {
	const [newTotal, setNewTotal] = useState(props?.record?.total);
	console.log('props',props)

	const onChangeTotal = (e) => {
		setNewTotal(e);
	};

	const dataToEdit = dataAdapter(props?.record?.code_internal, newTotal, props?.record?.quantity);

	const handleCloseModal = () => {
		setNewTotal(props?.record?.total);
		props?.setOpenEditPrice(false);
	};

	return (
		<CustomModal onCancel={handleCloseModal} footer={null} open={props?.openEditPrice}>
			<h2>Editar precio final unitario</h2>
			<CustomDivider />
			<h3>Datos</h3>

			<Row>
				<Col span={12}>
					<h3>Precio Actual</h3>
					<CustomInputNumber value={`$ ${props?.record?.unit_price}`} placeholder="Precio Actual" disabled={true} />
				</Col>
				<Col span={12}>
					<h3>Nuevo Precio</h3>
					<CustomInputNumber onChange={onChangeTotal} defaultValue={0} placeholder="Nuevo Precio" disabled={false} prefix={'$'} min={0} max={props?.record?.unit_price} />
				</Col>
			</Row>
			<CustomDivider />
			<div className="button-container">
				<CustomButton onClick={handleCloseModal}>Cancelar</CustomButton>
				<CustomButton onClick={() => props?.handleConfirmEdit(dataToEdit)}>Guardar </CustomButton>
			</div>
		</CustomModal>
	);
}
